module.exports = __webpack_public_path__ + "static/irrigation-video-e054d020b2dd6756e74f68b2cfd66e3e.webm";